import TabList from './components/TabList';
import ClassDashboard from './components/ClassDashboard';
import NavBar from './components/NavBar';
import { DataProvider } from '../../context/dataContext';


const MainPage = () => {

  return (
    <DataProvider>
      <NavBar />
      <TabList />
      <ClassDashboard />
    </DataProvider>
  );
};

export default MainPage;
